import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=509c8a19&scoped=true"
import script from "./Settings.vue?vue&type=script&setup=true&lang=js"
export * from "./Settings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=509c8a19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509c8a19",
  null
  
)

export default component.exports